import { defer } from 'lodash-es';
import anime from 'animejs';
import scroll from 'core/scroll';
import { frameToMs } from 'helpers/easings';
import Page from './Page';
export default class MainPage extends Page {
    ready = false;
    /* LOAD */
    async askPreload(previousPage) {
        this.el.classList.add('appearing');
        await super.askPreload(previousPage);
    }
    /* SHOW */
    show(previousPage) {
        this.resize();
        scroll.lock();
        const delay = previousPage ? 10 : 300;
        return Promise.resolve()
            .then(() => anime({
            targets: this.el,
            opacity: {
                value: [0, 1],
                duration: frameToMs(7.5),
                delay,
                easing: 'linear'
            },
            delay,
            changeBegin: () => this.showChildren()
        }).finished)
            .then(() => {
            scroll.unlock();
            this.el.style.transform = '';
            defer(() => this.resize());
        });
    }
    navigateToHash() {
        if (window.location.hash)
            document.querySelector(window.location.hash)?.scrollIntoView({ behavior: 'smooth' });
    }
    getChildrenShowDelay() {
        return 1;
    }
    showChildren() {
        setTimeout(() => {
            this.ready = true;
            this.invoke('show');
        }, this.getChildrenShowDelay());
    }
    transitionComplete() {
        this.el.classList.remove('appearing');
        super.transitionComplete();
    }
    resize() {
        if (this.ready)
            super.resize();
    }
    /* HIDE */
    hide(nextPage) {
        this.el.classList.add('disappearing');
        return anime({
            targets: this.el,
            opacity: {
                value: [1, 0],
                easing: 'linear',
                duration: frameToMs(7.5)
            }
            // delay: 100
        }).finished.then(() => {
        });
    }
}
